export default __webpack_public_path__ + "static/media/gadgets.8cfcc53d.svg";